<template>
  <div class="clouddisktwo">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class="active"><a href="#">我的云盘</a></li>

          <li class="fr"><router-link to="/home/cloudDisk">全部文件夹</router-link> > <router-link :to="{name: 'cloudDiskOne', params: { path: lastPath, name: lastName }}">{{lastName}}</router-link> > <a href="javascript:void(0)">{{name}}</a></li>
        </ul>
      </nav>
    </div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      class="messagelist">
      <el-table-column
        label="文件名"
        width="380">
        <template slot-scope="scope">
          <i class="txticon" v-show="scope.row.isDirectory==='false'" v-if="scope.row.name.endsWith('.txt')"></i><span v-if="scope.row.name.endsWith('.txt')" class="file-name" :title="scope.row.name" v-show="scope.row.isDirectory==='false'" @click="showTxt(scope.row)">{{ scope.row.name }}</span>
          <el-dialog custom-class="txtDialog" :title="title" :visible.sync="txtFormVisible" append-to-body :close-on-click-modal="false">
            <span>{{content}}</span>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="copyUrl">复制链接</el-button>
            </span>
          </el-dialog>
          <i class="zipicon" v-show="scope.row.isDirectory==='false'" v-if="!scope.row.name.endsWith('.txt')"></i><span v-if="!scope.row.name.endsWith('.txt')" class="file-name" :title="scope.row.name" v-show="scope.row.isDirectory==='false'">{{ scope.row.name }}</span>
          <p class="goerr" v-show="scope.row.isDirectory==='true'">
            <i class="el-icon-folder"></i><a href="javascript:void(0)" @click="gotoItem(scope.row)">{{ scope.row.name }}</a>
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="size"
        label="大小"
        align="center"
        width="180">
      </el-table-column>
      <el-table-column
        prop="time"
        label="修改时间"
        align="center"
        width="180">
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="looktd"
        >
        <template slot-scope="scope">
          <a href="javascript:void(0)" class="lookfor" v-if="scope.row.name.endsWith('.txt')" v-show="scope.row.isDirectory==='false'" @click="downLoadFile(scope.row)">下载</a>
            <a href="javascript:void(0)" class="lookfor" v-else v-show="scope.row.isDirectory==='false'" @click="downLoadFileNew(scope.row)">下载</a>
            <a href="javascript:void(0)" class="lookfor" @click="gotoItem(scope.row)" v-show="scope.row.isDirectory==='true'">查看</a>
          <!-- <a href="javascript:void(0)" @click="downLoadFile(scope.row)" class="lookfor">下载</a> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="total>pageSize">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        background
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'clouddisktwo',
  components: {
  },
  created () {
    this.lastPath = this.$route.params.lastPath
    this.lastName = this.$route.params.lastName
    this.path = this.$route.params.path
    this.name = this.$route.params.name
    this.readSonFolder(this.path)
  },
  data () {
    return {
      currentPage: 1,
      total: 0,
      pageSize: 5,
      lastPath: '',
      lastName: '',
      path: '',
      name: '',
      tableData: [],
      content: '',
      txtFormVisible: false
    }
  },
  methods: {
    showTxt(file) {
      let query = {
        fileName: file.name,
        filePath: file.path
      }
      this.$http({
        method: 'post',
        url: '/dmc/account/downLoadFiles',
        data: query,
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }]
      }).then(res => {
        var content = res.data
        var contentArr = content.split('下载链接列表')
        this.txtFormVisible = true
        this.title = '下载链接：'
        this.content = contentArr[0]
      })
    },
    copyUrl() {
      this.$copyText(this.content).then(r => {
        this.$message.success('链接复制成功')
      })
    },
    downLoadFileNew(file) {
      let downloadPath = file.downloadPath
      window.location.href = `${downloadPath}`
      return false
    },
    readSonFolder(path) {
      let queryParams = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        path: path
      }
      this.sapost('/dmc/account/readSonFolder', queryParams, r => {
        let { retMsg, retCode, pager } = r.data
        if (retCode === '0') {
          this.total = pager.total
          this.pageSize = pager.pageSize
          this.tableData = pager.list
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.readSonFolder(this.$route.params.path)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.readSonFolder(this.$route.params.path)
    },
    gotoItem(p) {
      this.readSonFolder(p.path)
    },
    downLoadFile(file) {
      let query = {
        fileName: file.name,
        filePath: file.path
      }
      this.$http({
        method: 'post',
        url: '/dmc/account/downLoadFiles',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: query,
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }]
      }).then(res => {
        // 这里res.data是返回的blob对象
        var blob = new Blob([res.data], {type: 'application/actet-stream;charset=utf-8'})
        var contentDisposition = res.headers['content-disposition'] // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
        var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
        var result = patt.exec(contentDisposition)
        var filename = result[1]
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob) // 创建下载的链接
        downloadElement.style.display = 'none'
        downloadElement.href = href
        filename = decodeURI(filename, 'UTF-8')
        downloadElement.download = filename // 下载后文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() // 点击下载
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
      })
    }
  }
}
</script>

<style lang="less">
.clouddisktwo{
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  .t-nav {
    nav{
      border-bottom: 2px solid #ddd;
      ul {
        margin-right: 15px;
        height: 60px;
        color: #b4b8bb;
        li{
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 45px;
          a{
            color:#b4b8bb;
          }
        }
        li.active,li:hover {
          border-bottom: 2px solid #f01400;
          a{
            color:#f01400;
          }
        }
        li.fr{
          float:right;
          margin-right: 0px;
          color: #333;
          a{
            color: #333;
            font-size: 12px;
          }
          a:hover{
            color: #f01400;
          }
        }
        li.fr:hover{
          border-bottom: none;
        }
      }
    }
  }
  .r-title{
    float: right;
    height: 60px;
    line-height: 60px;
    span{
      color: #f01400;
    }
  }
  .pages{
    text-align: right;
    padding-top: 15px;
  }
  .messagelist {
    .el-table__body tr:hover>td{
      background-color:#fef3f3;
    }
    tr:hover {
      td{
        border-bottom:1px solid #fef3f3;
      }
      .lookfor{
        background-color: #f20d0c;
        color: #fff;
        padding: 3px 29px;
        border-radius: 29px;
        display: inline-block;
      }
      td.looktd{
        padding: 6px 0;
      }
    }
    .file-name{
      display: inline-block;
      width: 330px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      vertical-align: bottom;
    }
    .cell{
      color:#333;
      i{
        font-size: 24px;
        margin-right: 5px;
        color: #ffb805;
      }
      i.txticon{
        height: 24px;
        width: 24px;
        background: url('../../assets/img/txt-icon.png') no-repeat center;
        background-size: 100%;
        vertical-align: middle;
      }
      i.zipicon{
        display:inline-block;
        height: 24px;
        width: 24px;
        background: url('../../assets/img/zip-icon.png') no-repeat center;
        background-size: 100%;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/clouddisktwo.vue